import React, { useEffect } from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import { Row, Col } from 'react-bootstrap';
import { MultiSelect } from 'react-multi-select-component';
import { useDispatch } from 'react-redux';
import { isEmpty, set } from 'lodash';
import { useTranslation } from 'react-i18next';
import * as action from '../Store/Pom.action';
import { useGradingGroupListingState, buildGradingListParams } from './GradingListionProvider';
import CustomTooltip from '../../../../Components/Tooltip/CustomTooltip';
import { getMultiSubBrandDetails } from '../../../SystemMasters/Store/SystemMasters.action';

function GradingFilter() {
  const statusOption = [
    { label: 'Active', value: 'active' },
    { label: 'Inactive', value: 'inactive' },
  ];
  const dispatch = useDispatch();
  const { t } = useTranslation('common');
  const { gradingListingState, loggedInUserId, setgradingListing } = useGradingGroupListingState();
  const { selectCategoryThree, selectGradingBrand, selectCategoryOne, selectCategoryTwo, isFilter, selectSubBrand } = gradingListingState;

  useEffect(() => {
    const fetchPurcahseOrder = async () => {
      const queryParams = {
        forGrading: true,
        isActive: 1,
        loggedInUserId,
      };
      await Promise.all([
        dispatch(action.fetchBrandsForGradingGroup(queryParams)),
        dispatch(action.fetchCategoryOneForGrading({ ...queryParams, categoryType: 1 })),
        dispatch(action.fetchCategoryTwoForGrading({ ...queryParams, categoryType: 2 })),
      ]);
    };
    fetchPurcahseOrder();
  }, [dispatch, loggedInUserId]);

  useEffect(() => {
    if (!isEmpty(selectGradingBrand)) {
      const queryParams = {
        brandId: selectGradingBrand,
      };
      dispatch(getMultiSubBrandDetails(queryParams));
    }
  }, [selectGradingBrand, dispatch]);

  const handleSelectChange = async (value, keyName) => {
    const copyState = { ...gradingListingState };
    if (keyName === 'selectGradingBrand' && value.length === 0) {
      copyState.selectSubBrand = [];
    }

    set(copyState, keyName, value);

    setgradingListing((prevState) => ({ ...prevState, ...copyState }));
  };

  useEffect(() => {
    if (!isEmpty(selectCategoryOne) && !isEmpty(selectCategoryTwo)) {
      const queryParams = {
        isActive: 1,
        loggedInUserId,
        categoryOneId: selectCategoryOne,
        categoryTwoId: selectCategoryTwo,
        categoryType: 3,
      };
      dispatch(action.fetchCategoryThreeForGrading(queryParams));
    }
  }, [selectCategoryOne, selectCategoryTwo, loggedInUserId, dispatch]);

  const handleFilterData = async () => {
    const filterObj = {
      brandId: selectGradingBrand,
      catOneId: gradingListingState?.selectCategoryOne,
      catTwoId: gradingListingState?.selectCategoryTwo,
      catThreeId: gradingListingState?.selectCategoryThree,
      status: gradingListingState?.selectStatus,
      subBrandId: selectSubBrand,
    };
    if (gradingListingState?.catBasedOnPTData && Array.isArray(gradingListingState?.selectProductType) && gradingListingState.selectProductType.length) {
      filterObj.productTypeId = gradingListingState.selectProductType;
    }
    localStorage.setItem('GradingListFilter', JSON.stringify(filterObj));
    dispatch(action.clearReducer());
    const reqObj = buildGradingListParams(gradingListingState, loggedInUserId, { pageIndex: 1 });
    setgradingListing((prev) => ({
      ...prev,
      isLoading: true,
      ListingData: [],
      pageIndex: 1,
      isFilter: true,
    }));

    const res = await dispatch(action.fetchGradingGroupData(reqObj));
    if (res) {
      setgradingListing((prev) => ({
        ...prev,
        isLoading: false,
      }));
    }
  };

  const handleClearData = async () => {
    if (localStorage.getItem('GradingListFilter')) {
      localStorage.removeItem('GradingListFilter');
    }
    setgradingListing((prev) => ({
      ...prev,
      isLoading: true,
      ListingData: [],
      selectGradingBrand: [],
      selectCategoryOne: [],
      selectCategoryTwo: [],
      selectCategoryThree: [],
      selectSubBrand: [],
      selectStatus: [],
      selectProductType: [],
      isFilter: false,
    }));
    dispatch(action.clearReducer());
    const reqObj = {
      pageIndex: 1,
      pageSize: gradingListingState?.pageSize,
      loggedInUserId,
      isPubParam: 1,
    };
    setgradingListing((prev) => ({
      ...prev,
      isLoading: true,
    }));

    const res = await dispatch(action.fetchGradingGroupData(reqObj));
    if (res) {
      setgradingListing((prev) => ({
        ...prev,
        isLoading: false,
      }));
    }
  };

  return (
    <CustomTooltip placement="auto" tooltipText={t('POMS.GRADING_GROUP_LISTING.GRADING_FILTER.MODAL_TITLE')}>
      <button aria-label={t('POMS.GRADING_GROUP_LISTING.GRADING_FILTER.MODAL_TITLE')} className={isFilter ? 'btn active' : 'btn'} type="button">
        <OverlayTrigger
          placement="bottom"
          trigger="click"
          rootClose
          overlay={
            <Popover className="custom-popover horizontal-view">
              <Popover.Content>
                <div className="product-costing-filter rangeplan-filter">
                  {/* ===== Row 1 ===== */}
                  <Row className="form-row">
                    <Col md={4}>
                      <div className="common-react-select">
                        <p className="field-name text-bold">{t('POMS.GRADING_GROUP_LISTING.GRADING_FILTER.BRAND')}</p>
                        <MultiSelect
                          name="Brand"
                          options={gradingListingState?.BrandData}
                          className="product-custom-multiselect common-new-multiselect"
                          value={gradingListingState?.BrandData?.filter((val) => selectGradingBrand?.includes(val?._id))}
                          onChange={(selected) =>
                            handleSelectChange(
                              selected.map((val) => val?._id),
                              'selectGradingBrand',
                            )
                          }
                        />
                      </div>
                    </Col>

                    {gradingListingState?.isSubBrandAccess ? (
                      <>
                        {/* Sub Brand visible case */}
                        <Col md={4}>
                          <div className="common-react-select">
                            <p className="field-name text-bold">{t('POMS.GRADING_GROUP_LISTING.GRADING_FILTER.SUB_BRAND')}</p>
                            <MultiSelect
                              name="SubBrand"
                              options={!isEmpty(selectGradingBrand) ? gradingListingState?.SubBrandData.filter((val) => val?.isActive) : []}
                              className="product-custom-multiselect common-new-multiselect"
                              value={!isEmpty(selectGradingBrand) ? gradingListingState?.SubBrandData?.filter((val) => selectSubBrand?.includes(val?._id)) : []}
                              onChange={(selected) =>
                                handleSelectChange(
                                  selected.map((val) => val?._id),
                                  'selectSubBrand',
                                )
                              }
                            />
                          </div>
                        </Col>

                        <Col md={4}>
                          <div className="common-react-select">
                            <p className="field-name text-bold">Product Type</p>
                            <MultiSelect
                              name="ProductType"
                              options={gradingListingState?.ProductTypeData}
                              className="product-custom-multiselect common-new-multiselect"
                              value={gradingListingState?.ProductTypeData?.filter((val) => gradingListingState?.selectProductType?.includes(val?._id))}
                              onChange={(selected) =>
                                handleSelectChange(
                                  selected.map((val) => val?._id),
                                  'selectProductType',
                                )
                              }
                            />
                          </div>
                        </Col>
                      </>
                    ) : (
                      <>
                        {/* Sub Brand hidden case */}
                        <Col md={4}>
                          <div className="common-react-select">
                            <p className="field-name text-bold">Product Type</p>
                            <MultiSelect
                              name="ProductType"
                              options={gradingListingState?.ProductTypeData}
                              className="product-custom-multiselect common-new-multiselect"
                              value={gradingListingState?.ProductTypeData?.filter((val) => gradingListingState?.selectProductType?.includes(val?._id))}
                              onChange={(selected) =>
                                handleSelectChange(
                                  selected.map((val) => val?._id),
                                  'selectProductType',
                                )
                              }
                            />
                          </div>
                        </Col>

                        <Col md={4}>
                          <div className="common-react-select">
                            <p className="field-name text-bold">{t('POMS.GRADING_GROUP_LISTING.GRADING_FILTER.CATEGORY_1')}</p>
                            <MultiSelect
                              name="CategoryOne"
                              options={gradingListingState?.CategoryOneData}
                              className="product-custom-multiselect common-new-multiselect"
                              value={gradingListingState?.CategoryOneData?.filter((val) => selectCategoryOne?.includes(val?._id))}
                              onChange={(selected) =>
                                handleSelectChange(
                                  selected.map((val) => val?._id),
                                  'selectCategoryOne',
                                )
                              }
                            />
                          </div>
                        </Col>
                      </>
                    )}
                  </Row>

                  {/* ===== Row 2 ===== */}
                  <Row>
                    {gradingListingState?.isSubBrandAccess ? (
                      <>
                        <Col md={4}>
                          <div className="common-react-select">
                            <p className="field-name text-bold">{t('POMS.GRADING_GROUP_LISTING.GRADING_FILTER.CATEGORY_1')}</p>
                            <MultiSelect
                              name="CategoryOne"
                              options={gradingListingState?.CategoryOneData}
                              className="product-custom-multiselect common-new-multiselect"
                              value={gradingListingState?.CategoryOneData?.filter((val) => selectCategoryOne?.includes(val?._id))}
                              onChange={(selected) =>
                                handleSelectChange(
                                  selected.map((val) => val?._id),
                                  'selectCategoryOne',
                                )
                              }
                            />
                          </div>
                        </Col>

                        <Col md={4}>
                          <div className="common-react-select">
                            <p className="field-name text-bold">{t('POMS.GRADING_GROUP_LISTING.GRADING_FILTER.CATEGORY_2')}</p>
                            <MultiSelect
                              name="CategoryTwo"
                              options={gradingListingState?.CategoryTwoData}
                              className="product-custom-multiselect common-new-multiselect"
                              value={gradingListingState?.CategoryTwoData?.filter((val) => selectCategoryTwo?.includes(val?._id))}
                              onChange={(selected) =>
                                handleSelectChange(
                                  selected.map((val) => val?._id),
                                  'selectCategoryTwo',
                                )
                              }
                            />
                          </div>
                        </Col>

                        <Col md={4}>
                          <div className="common-react-select">
                            <p className="field-name text-bold">{t('POMS.GRADING_GROUP_LISTING.GRADING_FILTER.CATEGORY_3')}</p>
                            <MultiSelect
                              name="CategoryThree"
                              options={gradingListingState?.CategoryThreeData}
                              className="product-custom-multiselect common-new-multiselect"
                              value={gradingListingState?.CategoryThreeData?.filter((val) => selectCategoryThree?.includes(val?._id))}
                              onChange={(selected) =>
                                handleSelectChange(
                                  selected.map((val) => val?._id),
                                  'selectCategoryThree',
                                )
                              }
                            />
                          </div>
                        </Col>
                      </>
                    ) : (
                      <>
                        <Col md={4}>
                          <div className="common-react-select">
                            <p className="field-name text-bold">{t('POMS.GRADING_GROUP_LISTING.GRADING_FILTER.CATEGORY_2')}</p>
                            <MultiSelect
                              name="CategoryTwo"
                              options={gradingListingState?.CategoryTwoData}
                              className="product-custom-multiselect common-new-multiselect"
                              value={gradingListingState?.CategoryTwoData?.filter((val) => selectCategoryTwo?.includes(val?._id))}
                              onChange={(selected) =>
                                handleSelectChange(
                                  selected.map((val) => val?._id),
                                  'selectCategoryTwo',
                                )
                              }
                            />
                          </div>
                        </Col>

                        <Col md={4}>
                          <div className="common-react-select">
                            <p className="field-name text-bold">{t('POMS.GRADING_GROUP_LISTING.GRADING_FILTER.CATEGORY_3')}</p>
                            <MultiSelect
                              name="CategoryThree"
                              options={gradingListingState?.CategoryThreeData}
                              className="product-custom-multiselect common-new-multiselect"
                              value={gradingListingState?.CategoryThreeData?.filter((val) => selectCategoryThree?.includes(val?._id))}
                              onChange={(selected) =>
                                handleSelectChange(
                                  selected.map((val) => val?._id),
                                  'selectCategoryThree',
                                )
                              }
                            />
                          </div>
                        </Col>

                        <Col md={4}>
                          <div className="common-react-select">
                            <p className="field-name text-bold">{t('POMS.GRADING_GROUP_LISTING.GRADING_FILTER.STATUS')}</p>
                            <MultiSelect
                              name="Status"
                              options={statusOption}
                              className="product-custom-multiselect common-new-multiselect"
                              value={statusOption.filter((val) => gradingListingState?.selectStatus?.includes(val?.value))}
                              onChange={(selected) => {
                                const selectedStatus = selected?.map((status) => status.value);
                                handleSelectChange(selectedStatus, 'selectStatus');
                              }}
                            />
                          </div>
                        </Col>
                      </>
                    )}
                  </Row>

                  {/* ===== Row 3 (only when SubBrand visible) ===== */}
                  {gradingListingState?.isSubBrandAccess && (
                    <Row>
                      <Col md={4}>
                        <div className="common-react-select">
                          <p className="field-name text-bold">{t('POMS.GRADING_GROUP_LISTING.GRADING_FILTER.STATUS')}</p>
                          <MultiSelect
                            name="Status"
                            options={statusOption}
                            className="product-custom-multiselect common-new-multiselect"
                            value={statusOption.filter((val) => gradingListingState?.selectStatus?.includes(val?.value))}
                            onChange={(selected) => {
                              const selectedStatus = selected?.map((status) => status.value);
                              handleSelectChange(selectedStatus, 'selectStatus');
                            }}
                          />
                        </div>
                      </Col>
                    </Row>
                  )}

                  {/* ===== Buttons ===== */}
                  <div className="d-flex justify-content-end mt-2">
                    <CustomTooltip tooltipText={t('POMS.GRADING_GROUP_LISTING.GRADING_FILTER.CLEAR')}>
                      <button type="button" aria-label="clear" className="btn p-0" onClick={handleClearData}>
                        <i className="icon-Clear-New f-24" />
                      </button>
                    </CustomTooltip>
                    <CustomTooltip tooltipText={t('POMS.GRADING_GROUP_LISTING.GRADING_FILTER.APPLY')}>
                      <button type="button" aria-label="save" className="btn p-0 ml-16" onClick={handleFilterData}>
                        <i className="icon-Tick-1 f-24" />
                      </button>
                    </CustomTooltip>
                  </div>
                </div>
              </Popover.Content>
            </Popover>
          }
        >
          <i className="icon-Filter f-26" />
        </OverlayTrigger>
      </button>
    </CustomTooltip>
  );
}

export default GradingFilter;
